const countTotalNumberOfItems = boxesMap => {
  let count = 0;
  for (const box in boxesMap) {
    const { items } = boxesMap[box];
    count += items?.length ?? 0;
  }
  return count;
};

const findAllItemsMissingReturnReason = boxesMap =>
  Object.values(boxesMap).flatMap(box => {
    const { items = [] } = box;
    return items.filter(item => !item.reasonCode);
  });

/**
 * Include link back to order if navigated here from it
 * If there's no previous order id info, it'll direct back to account overview
 * If there's multiple orders in this return, say, batch return, it'll direct to batch return instead
 */
const getBreadcrumbsLinks = (order, preReturnInfo) => {
  if (!order?.orderId) {
    return [];
  }

  return preReturnInfo.length === 1 ? [{ text: 'Order Information', to: `/orders/${order.orderId}` }] : [{ text: 'Returns', to: '/returns' }];
};

const checkIfReturnAlreadySubmitted = returnItems => orderDetailsResponse => {
  const { lineItems: lineItemsFromOrderDetail } = orderDetailsResponse;

  for (let i = 0; i < returnItems.length; i++) {
    const {
      product: { asin: returnItemAsin }
    } = returnItems[i];

    const lineItemFilters = {
      matchingReturnItemAsin: lineItem => {
        const {
          product: { asin }
        } = lineItem;
        return asin === returnItemAsin;
      },
      returnableItem: lineItem => {
        const { returnable } = lineItem;
        return returnable;
      }
    };

    const duplicateOrderItems = lineItemsFromOrderDetail.filter(lineItemFilters.matchingReturnItemAsin);

    if (duplicateOrderItems.length > 1) {
      const duplicateReturnItems = returnItems.filter(lineItemFilters.matchingReturnItemAsin);
      const duplicateReturnableItems = duplicateOrderItems.filter(lineItemFilters.returnableItem);

      const thereAreMoreDuplicateItemsToReturnThanReturnableInOrder = duplicateReturnItems.length > duplicateReturnableItems.length;
      if (thereAreMoreDuplicateItemsToReturnThanReturnableInOrder) {
        return true;
      }
    } else {
      const { returnable: isUniqueItemReturnable } = duplicateOrderItems[0];
      if (!isUniqueItemReturnable) {
        return true;
      }
    }
  }
};

/**
 * We do not want to authorize pick-ups for returns involving multiple orders
 */
const shouldAuthorizePickups = (arePickUpAuthorized, akitaPickup, returns) => {
  if (!arePickUpAuthorized || !akitaPickup || returns.boxInfo['2']) {
    return false;
  }
  const uniqueOrders = returns.boxInfo['1'].items.reduce((uniqueOrderIds, item) => uniqueOrderIds.add(item.orderId), new Set());
  return uniqueOrders.size === 1;
};
const hasMultiItemsForReturn = returns => {
  const { preReturnInfo } = returns;
  if (!preReturnInfo || !preReturnInfo[0]) {
    return false;
  }

  return preReturnInfo.length > 1 || preReturnInfo[0].returnItems?.length > 1;
};

const selectedItemContainsConfigMatch = (selectedItem, groupableReturnConfigs) =>
  groupableReturnConfigs?.some(returnConfig => selectedItem.groupableReturnConfigs?.includes(returnConfig));

const canItemBeReturnedWithSelectedItems = (lineItem, selectedItems) => {
  if (!selectedItems || selectedItems.length === 0) {
    return true;
  }
  const { groupableReturnConfigs } = lineItem;
  const selectedItemConfigMatchMap = selectedItems.map(item => selectedItemContainsConfigMatch(item, groupableReturnConfigs));

  return selectedItemConfigMatchMap.every(containsMatch => containsMatch === true);
};

export const RETURN_REFUND_VERBIAGE =
  'Reminder – Items must be unworn, in their original state, and accompanied by the original packaging. The condition in which your items are returned could impact your refund.';

export default {
  countTotalNumberOfItems,
  findAllItemsMissingReturnReason,
  getBreadcrumbsLinks,
  checkIfReturnAlreadySubmitted,
  shouldAuthorizePickups,
  hasMultiItemsForReturn,
  canItemBeReturnedWithSelectedItems
};
